<template>
  <div class="">
    <!-- 搜索及筛选 -->
    <div class="whiteBg main-top">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="box box-align-center mt-input">
            <div class="mti-txt">资源类型：</div>
            <el-select v-model="fileType" placeholder="请选择资源类型" @change="handleChange">
              <el-option v-for="item in resourcesList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="box box-align-center mt-input">
            <el-button type="text" @click="clickDate">今日</el-button>
            <el-button type="text" @click="clickWeek">本周</el-button>
            <el-button type="text" @click="clickMonth">本月</el-button>
            <div class="mti-txt ml20">开始时间-结束时间：</div>
            <el-date-picker @change="dateChange" v-model="sendTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </el-col>
      </el-row>
      <div class="mt20">
        <dy-table
          :columns="fbColumns"
          :table-data="fbTableData"
          ref="fbTable"
          v-loading="fbTableLoading"
          :total="fbTotal"
          :page-num="fbCurrentPage"
          :page-size="10"
          @current-change="onCurrentChangeFb"
          element-loading-text="加载中"
        ></dy-table>
      </div>
    </div>
  </div>
</template>
<script>
import { encrypt, decrypt } from '@/api/common_encrypt';
import { selectHotStat } from '@/api/index';
import { getTodayDate, getStartAndEndOfWeek, getMonthStartEnd } from '@/utils/utils';
import { resourcesList } from '@/utils/commonData';
import DyTable from '@/components/common/dytable';
export default {
  components: {
    DyTable,
  },
  data() {
    return {
      options: [],
      sendTime: null,
      fileType: null,
      resourcesList,
      fbTableData: [],
      fbTableLoading: false,
      fbTotal: 0,
      fbCurrentPage: 1,
      fbColumns: [
        {
          type: 'index',
          title: '序号',
        },
        {
          key: 'resourceName',
          title: '资源名称',
        },
        {
          key: 'usedNum',
          title: '引用数量',
        },
        {
          key: 'categoryName',
          title: '资源分类',
        },
        {
          key: 'creatorName',
          title: '制作人',
        },
      ],
    };
  },
  mounted() {
    // this.getList();
    this.clickDate();
  },
  methods: {
    handleChange(val) {
      this.clickDate();
    },
    onCurrentChangeFb(val) {
      this.fbCurrentPage = val;
      this.getList();
    },
    clickDate() {
      const date = getTodayDate();
      this.getList(date, date);
    },
    clickWeek() {
      const { start, end } = getStartAndEndOfWeek();
      const date = getTodayDate();
      this.getList(start, date);
    },
    clickMonth() {
      const { start, end } = getMonthStartEnd();
      this.getList(start, end);
    },
    dateChange(val) {
      const date = getTodayDate();
      const start = val ? val[0] : date;
      const end = val ? val[1] : date;
      this.getList(start, end);
    },
    getList(from, to) {
      this.fbTableLoading = true;
      let info = {
        from,
        to,
        page: this.fbCurrentPage,
        pageSize: 10,
        fileType: this.fileType,
      };
      console.log('9999', info);
      var data = encrypt(JSON.stringify(info));
      selectHotStat(data).then((res) => {
        console.log('res,,,,,....', res);
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('-----列表', ress);
          this.fbTotal = ress.total;
          this.fbCurrentPage = ress.pageNum;
          this.fbTableData = ress.list.map((item) => {
            return {
              ...item,
            };
          });
          this.fbTableLoading = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0;
}

/deep/.el-dropdown {
  margin-right: 10px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  display: block;
  white-space: nowrap;
}
// /deep/.el-tabs__header {
//     margin: 0;
// }
.main {
  padding-top: 0 !important;
  padding-right: 0 !important;
}
.mt20 {
  margin-top: 20px;
}

.main-top {
  padding: 20px 15px;
  border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

  .mti-txt {
    white-space: nowrap;
  }
  .ml20 {
    margin-left: 20px;
  }
}

.main-middle {
  padding: 15px 11px;
}

.common-btns {
  padding: 0 22px 33px;
}
</style>
